export enum FeedbackRatingEnum {
  Great = "😃",
  Good = "🙂",
  Okay = "😐",
  Bad = "🙁",
  Terrible = "😠",
}

export const FeedbackRatingNumeric = {
  [FeedbackRatingEnum.Great]: 2,
  [FeedbackRatingEnum.Good]: 1,
  [FeedbackRatingEnum.Okay]: 0,
  [FeedbackRatingEnum.Bad]: -1,
  [FeedbackRatingEnum.Terrible]: -2,
};

export enum FeedbackCategories {
  Interviewer = "interviewer",
  TechnicalDifficulties = "technical-difficulties",
  InterviewFormat = "interviewer-format",
  Timeliness = "timeliness",
  InterviewQuestions = "interview-questions",
  InterpersonalSkills = "interpersonal-skills",
}
